import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock-upgrade';

import { getPageButtons } from '../../modules/utils';

// let filterToggle = document.getElementById('js-filters-toggle');

// let filters = document.getElementById('js-filters');

/**
 * Open filters, lock scrolling, disable tabbing to elements outside filters, and focus on first element inside filters
 */
function openFilters() {
  const filters = document.getElementById('js-filters');
  if (!filters) {
    return;
  }

  // disable scrolling everywhere except modal content
  const targetElement = filters.querySelector('.filters__inner') as HTMLElement;
  disableBodyScroll(targetElement);

  // show the modal
  filters.classList.add('filters--open');
  filters.setAttribute('aria-hidden', 'false');

  // set tabindex of all clickable elements outside modal to -1
  const filterBtns = getPageButtons();
  filterBtns.forEach((btn) => {
    btn.setAttribute('tabindex', '-1');
  });

  // set tabindex of modal clickable elements to 0
  const filterLinks = filters.querySelectorAll('select, input, textarea, button, a, iframe') as NodeListOf<HTMLElement>;
  filterLinks.forEach((link) => {
    link.setAttribute('tabindex', '0');
  });
  filterLinks[0].focus();
}

/**
 * Close filters, unlock scrolling, enable tabbing to elements outside filters, and focus on original element
 * @param modalName Name of the modal (the data-modal attribute)
 * @param origFocus The element that was focused before the modal opened
 */
function closeFilters(origFocus?: HTMLElement) {
  const filters = document.getElementById('js-filters');
  if (!filters) {
    return;
  }

  clearAllBodyScrollLocks();

  // set tabindex of page elements back to 0
  const pageBtns = getPageButtons();
  pageBtns.forEach((btn) => {
    btn.setAttribute('tabindex', '0');
  });

  if (filters) {
    // hide the modal
    filters.classList.remove('filters--open');
    filters.setAttribute('aria-hidden', 'true');

    // set tabindex of modal elements back to -1
    let filterLinks = filters.querySelectorAll('select, input, textarea, button, a, iframe');
    filterLinks.forEach((link) => {
      link.setAttribute('tabindex', '-1');
    });
  }

  // move focus back to original focus before modal opened
  if (origFocus) {
    origFocus.focus();
  }

  // Emit modal close event
  filters.dispatchEvent(new CustomEvent('close', { bubbles: true }));
}

// The actual event listener to hook it all up
document.addEventListener('DOMContentLoaded', () => {
  let origFocus;

  // open filters when clicking on button
  const filterOpenBtns = document.querySelectorAll('.js-filter-open');
  filterOpenBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      origFocus = e.target;

      openFilters();
    });
  });

  // close filters when clicking on close button
  const filterCloseBtns = document.querySelectorAll('.js-filter-close');
  filterCloseBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeFilters(origFocus);
    });
  });

  // close filters when clicking on overlay
  const overlay = document.querySelector('.filters__overlay');

  overlay?.addEventListener('click', () => {
    closeFilters(origFocus);
  });

  // Close filters when pressing ESC
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeFilters(origFocus);
    }
  });
});
